// extracted by mini-css-extract-plugin
export default {"HeaderTagline":"HeaderTagline_HeaderTagline__LoXtU"};